import { useAuth } from '../../auth/AuthContext';
import { getRoleLabel } from '../../auth/roles';
import './Dashboard.css';

function AccountSettings() {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <div className="dashboard-route-status" role="status">Loading account...</div>;
  }

  return (
    <section className="dashboard-page">
      <div className="dashboard-page-header">
        <div>
          <p className="eyebrow">Account</p>
          <h1>Settings</h1>
        </div>
      </div>

      <article className="dashboard-panel settings-panel">
        <dl className="detail-list">
          <div><dt>Name</dt><dd>{currentUser.name}</dd></div>
          <div><dt>Email</dt><dd>{currentUser.email}</dd></div>
          <div><dt>Role</dt><dd>{getRoleLabel(currentUser.role)}</dd></div>
          <div><dt>Organization</dt><dd>{currentUser.organization}</dd></div>
        </dl>
      </article>
    </section>
  );
}

export default AccountSettings;
